 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTSECTION0003 from '@/components/Text/Section0003'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXT01_TITLE from '@/components/Text/01_title'
 import TEXT02A_COPYRIGHTPAGE from '@/components/Text/02A_copyrightPage'
 import TEXT05_CHAPTER01 from '@/components/Text/05_chapter01'
 import TEXT06_CHAPTER02 from '@/components/Text/06_chapter02'
 import TEXT07_CHAPTER03 from '@/components/Text/07_chapter03'
 import TEXT08_CHAPTER04 from '@/components/Text/08_chapter04'
 import TEXT09_CHAPTER05 from '@/components/Text/09_chapter05'
 import TEXT10_CHAPTER06 from '@/components/Text/10_chapter06'
 import TEXT11_CHAPTER07 from '@/components/Text/11_chapter07'
 import TEXT12_CHAPTER08 from '@/components/Text/12_chapter08'
 import TEXT13_CHAPTER09 from '@/components/Text/13_chapter09'
 import TEXT14_CHAPTER10 from '@/components/Text/14_chapter10'
 import TEXT15_CHAPTER11 from '@/components/Text/15_chapter11'
 import TEXT16_CHAPTER12 from '@/components/Text/16_chapter12'
 import TEXT17_CHAPTER13 from '@/components/Text/17_chapter13'
 import TEXT18_CHAPTER14 from '@/components/Text/18_chapter14'
 import TEXT19_CHAPTER15 from '@/components/Text/19_chapter15'
 import TEXT20_CHAPTER16 from '@/components/Text/20_chapter16'
 import TEXT21_CHAPTER17 from '@/components/Text/21_chapter17'
 import TEXT22_CHAPTER18 from '@/components/Text/22_chapter18'
 import TEXT23_CHAPTER19 from '@/components/Text/23_chapter19'
 import TEXT24_CHAPTER20 from '@/components/Text/24_chapter20'
 import TEXT25_CHAPTER21 from '@/components/Text/25_chapter21'
 import TEXT26_CHAPTER22 from '@/components/Text/26_chapter22'
 import TEXT27_CHAPTER23 from '@/components/Text/27_chapter23'
 import TEXT28_CHAPTER24 from '@/components/Text/28_chapter24'
 import TEXT29_CHAPTER25 from '@/components/Text/29_chapter25'
 import TEXT30_CHAPTER26 from '@/components/Text/30_chapter26'
 import TEXT31_CHAPTER27 from '@/components/Text/31_chapter27'
 import TEXT32_CHAPTER28 from '@/components/Text/32_chapter28'
 import TEXT01_TITLE_ from '@/components/Text/01_title_'
 import TEXT02A_COPYRIGHTPAGE_ from '@/components/Text/02A_copyrightPage_'
 import TEXT05_CHAPTER01_ from '@/components/Text/05_chapter01_'
 import TEXT06_CHAPTER02_ from '@/components/Text/06_chapter02_'
 import TEXT07_CHAPTER03_ from '@/components/Text/07_chapter03_'
 import TEXT08_CHAPTER04_ from '@/components/Text/08_chapter04_'
 import TEXT09_CHAPTER05_ from '@/components/Text/09_chapter05_'
 import TEXT10_CHAPTER06_ from '@/components/Text/10_chapter06_'
 import TEXT11_CHAPTER07_ from '@/components/Text/11_chapter07_'
 import TEXT12_CHAPTER08_ from '@/components/Text/12_chapter08_'
 import TEXT13_CHAPTER09_ from '@/components/Text/13_chapter09_'
 import TEXT14_CHAPTER10_ from '@/components/Text/14_chapter10_'
 import TEXT15_CHAPTER11_ from '@/components/Text/15_chapter11_'
 import TEXT16_CHAPTER12_ from '@/components/Text/16_chapter12_'
 import TEXT17_CHAPTER13_ from '@/components/Text/17_chapter13_'
 import TEXT18_CHAPTER14_ from '@/components/Text/18_chapter14_'
 import TEXT19_CHAPTER15_ from '@/components/Text/19_chapter15_'
 import TEXT20_CHAPTER16_ from '@/components/Text/20_chapter16_'
 import TEXT21_CHAPTER17_ from '@/components/Text/21_chapter17_'
 import TEXT22_CHAPTER18_ from '@/components/Text/22_chapter18_'
 import TEXT23_CHAPTER19_ from '@/components/Text/23_chapter19_'
 import TEXT24_CHAPTER20_ from '@/components/Text/24_chapter20_'
 import TEXT25_CHAPTER21_ from '@/components/Text/25_chapter21_'
 import TEXT26_CHAPTER22_ from '@/components/Text/26_chapter22_'
 import TEXT27_CHAPTER23_ from '@/components/Text/27_chapter23_'
 import TEXT04_TITLE from '@/components/Text/04_title'
 import TEXT05_COPY from '@/components/Text/05_copy'
 import TEXT07_CH01 from '@/components/Text/07_ch01'
 import TEXT08_CH02 from '@/components/Text/08_ch02'
 import TEXT09_CH03 from '@/components/Text/09_ch03'
 import TEXT10_CH04 from '@/components/Text/10_ch04'
 import TEXT11_CH05 from '@/components/Text/11_ch05'
 import TEXT12_CH06 from '@/components/Text/12_ch06'
 import TEXT13_CH07 from '@/components/Text/13_ch07'
 import TEXT14_CH08 from '@/components/Text/14_ch08'
 import TEXT15_CH09 from '@/components/Text/15_ch09'
 import TEXT16_CH10 from '@/components/Text/16_ch10'
 import TEXT17_CH11 from '@/components/Text/17_ch11'
 import TEXT18_CH12 from '@/components/Text/18_ch12'
 import TEXT19_CH13 from '@/components/Text/19_ch13'
 import TEXT20_CH14 from '@/components/Text/20_ch14'
 import TEXT21_CH15 from '@/components/Text/21_ch15'
 import TEXT22_CH16 from '@/components/Text/22_ch16'
 import TEXT23_CH17 from '@/components/Text/23_ch17'
 import TEXT24_CH18 from '@/components/Text/24_ch18'
 import TEXT25_CH19 from '@/components/Text/25_ch19'
 import TEXT26_CH20 from '@/components/Text/26_ch20'
 import TEXT27_CH21 from '@/components/Text/27_ch21'
 import TEXT28_CH22 from '@/components/Text/28_ch22'
 import TEXT29_CH23 from '@/components/Text/29_ch23'
 import TEXT30_CH24 from '@/components/Text/30_ch24'
 import TEXT_03_TITLE from '@/components/Text/_03_title'
 import TEXT_03A_COPY from '@/components/Text/_03a_copy'
 import TEXT_05_CHAPTER01 from '@/components/Text/_05_chapter01'
 import TEXT_06_CHAPTER02 from '@/components/Text/_06_chapter02'
 import TEXT_07_CHAPTER03 from '@/components/Text/_07_chapter03'
 import TEXT_08_CHAPTER04 from '@/components/Text/_08_chapter04'
 import TEXT_09_CHAPTER05 from '@/components/Text/_09_chapter05'
 import TEXT_10_CHAPTER06 from '@/components/Text/_10_chapter06'
 import TEXT_11_CHAPTER07 from '@/components/Text/_11_chapter07'
 import TEXT_12_CHAPTER08 from '@/components/Text/_12_chapter08'
 import TEXT_13_CHAPTER09 from '@/components/Text/_13_chapter09'
 import TEXT_14_CHAPTER10 from '@/components/Text/_14_chapter10'
 import TEXT_15_CHAPTER11 from '@/components/Text/_15_chapter11'
 import TEXT_16_CHAPTER12 from '@/components/Text/_16_chapter12'
 import TEXT_17_CHAPTER13 from '@/components/Text/_17_chapter13'
 import TEXT_18_CHAPTER14 from '@/components/Text/_18_chapter14'
 import TEXT_19_CHAPTER15 from '@/components/Text/_19_chapter15'
 import TEXT_20_CHAPTER16 from '@/components/Text/_20_chapter16'
 import TEXT_21_CHAPTER17 from '@/components/Text/_21_chapter17'
 import TEXT_22_CHAPTER18 from '@/components/Text/_22_chapter18'
 import TEXT_23_CHAPTER19 from '@/components/Text/_23_chapter19'
 import TEXT_24_CHAPTER20 from '@/components/Text/_24_chapter20'
 import TEXT_25_CHAPTER21 from '@/components/Text/_25_chapter21'
 import TEXT_26_CHAPTER22 from '@/components/Text/_26_chapter22'
 import TEXT_27_CHAPTER23 from '@/components/Text/_27_chapter23'
 import TEXT_28_CHAPTER24 from '@/components/Text/_28_chapter24'
 import TEXT_29_CHAPTER25 from '@/components/Text/_29_chapter25'
 import TEXT_30_CHAPTER26 from '@/components/Text/_30_chapter26'
 import TEXT_31_CHAPTER27 from '@/components/Text/_31_chapter27'
 import TEXT_32_CHAPTER28 from '@/components/Text/_32_chapter28'
 import TEXT_33_CHAPTER29 from '@/components/Text/_33_chapter29'
 import TEXT_34_CHAPTER30 from '@/components/Text/_34_chapter30'
 import TEXT_35_CHAPTER31 from '@/components/Text/_35_chapter31'
 import LOVE_2 from '@/components/love_2'
 import TEXTCHAP270022 from '@/components/Text/chap270022'
 import TEXTCHAP270023 from '@/components/Text/chap270023'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/Section0003",
 			"name" : "Text/Section0003",
 			"component" : TEXTSECTION0003
 		},
 		{
 			"path" : "/Text/Section0002",
 			"name" : "Text/Section0002",
 			"component" : TEXTSECTION0002
 		},
 		{
 			"path" : "/Text/01_title",
 			"name" : "Text/01_title",
 			"component" : TEXT01_TITLE
 		},
 		{
 			"path" : "/Text/02A_copyrightPage",
 			"name" : "Text/02A_copyrightPage",
 			"component" : TEXT02A_COPYRIGHTPAGE
 		},
 		{
 			"path" : "/Text/05_chapter01",
 			"name" : "Text/05_chapter01",
 			"component" : TEXT05_CHAPTER01
 		},
 		{
 			"path" : "/Text/06_chapter02",
 			"name" : "Text/06_chapter02",
 			"component" : TEXT06_CHAPTER02
 		},
 		{
 			"path" : "/Text/07_chapter03",
 			"name" : "Text/07_chapter03",
 			"component" : TEXT07_CHAPTER03
 		},
 		{
 			"path" : "/Text/08_chapter04",
 			"name" : "Text/08_chapter04",
 			"component" : TEXT08_CHAPTER04
 		},
 		{
 			"path" : "/Text/09_chapter05",
 			"name" : "Text/09_chapter05",
 			"component" : TEXT09_CHAPTER05
 		},
 		{
 			"path" : "/Text/10_chapter06",
 			"name" : "Text/10_chapter06",
 			"component" : TEXT10_CHAPTER06
 		},
 		{
 			"path" : "/Text/11_chapter07",
 			"name" : "Text/11_chapter07",
 			"component" : TEXT11_CHAPTER07
 		},
 		{
 			"path" : "/Text/12_chapter08",
 			"name" : "Text/12_chapter08",
 			"component" : TEXT12_CHAPTER08
 		},
 		{
 			"path" : "/Text/13_chapter09",
 			"name" : "Text/13_chapter09",
 			"component" : TEXT13_CHAPTER09
 		},
 		{
 			"path" : "/Text/14_chapter10",
 			"name" : "Text/14_chapter10",
 			"component" : TEXT14_CHAPTER10
 		},
 		{
 			"path" : "/Text/15_chapter11",
 			"name" : "Text/15_chapter11",
 			"component" : TEXT15_CHAPTER11
 		},
 		{
 			"path" : "/Text/16_chapter12",
 			"name" : "Text/16_chapter12",
 			"component" : TEXT16_CHAPTER12
 		},
 		{
 			"path" : "/Text/17_chapter13",
 			"name" : "Text/17_chapter13",
 			"component" : TEXT17_CHAPTER13
 		},
 		{
 			"path" : "/Text/18_chapter14",
 			"name" : "Text/18_chapter14",
 			"component" : TEXT18_CHAPTER14
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js